export const transactionsAnalyticsStatsValues = {
  aboutToExpire: 'aboutToExpire',
  pendingApproval: 'pendingApproval',
  accepted: 'accepted',
  forReview: 'forReview',
  onHold: 'onHold',
}
